import { api } from "./api";

// Web-Push (VAPID) Helfer: Berechtigung anfragen, Subscription anlegen und
// serverseitig (mit Login-E-Mail aus dem Token) speichern.
function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

export function pushSupported() {
  return (
    typeof navigator !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

// Nur die installierte PWA (standalone) – NICHT der normale Desktop-/Mobil-Browser.
export function isPWA() {
  if (typeof window === "undefined") return false;
  const standalone = window.matchMedia && window.matchMedia("(display-mode: standalone)").matches;
  return !!(standalone || window.navigator.standalone);
}

export async function getPushState() {
  if (!pushSupported()) return "unsupported";
  if (Notification.permission === "denied") return "denied";
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    return sub ? "subscribed" : "default";
  } catch {
    return "default";
  }
}

export async function subscribePush(token) {
  if (!pushSupported()) throw new Error("Push wird von diesem Browser nicht unterstützt.");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Benachrichtigungen wurden nicht erlaubt.");
  const reg = await navigator.serviceWorker.ready;
  const { data } = await api.get("/push/vapid-public-key");
  const appServerKey = urlBase64ToUint8Array(data.publicKey);
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: appServerKey });
  }
  await api.post("/push/subscribe", { subscription: sub.toJSON(), role: sessionStorage.getItem("mag_role") || "" }, { headers: { Authorization: `Bearer ${token}` } });
  return true;
}

export async function unsubscribePush(token) {
  if (!pushSupported()) return;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    await api
      .post("/push/unsubscribe", { subscription: sub.toJSON() }, { headers: { Authorization: `Bearer ${token}` } })
      .catch(() => {});
    await sub.unsubscribe().catch(() => {});
  }
}
